import common from './common';
import account from './account';
import category from './category';
import event from './event';
import promotionSchedule from './promotionSchedule';
import tag from './tag';

export const ERROR_RESPONSE = {
  ...common,
  ...account,
  ...category,
  ...event,
  ...promotionSchedule,
  ...tag,
};
